import React from 'react';
import './Analytics.css';

const Analytics = () => {
  // Mock data - replace with API call
  const stats = {
    totalQueries: 1250,
    answeredQueries: 1180,
    unansweredQueries: 70,
    avgResponseTime: '1.2s',
    topQueries: [
      { question: 'What is the cancellation policy?', count: 45 },
      { question: 'How do I book a room?', count: 32 },
      { question: 'What are your check-in times?', count: 28 },
      { question: 'Do you offer refunds?', count: 21 },
      { question: 'What payment methods do you accept?', count: 18 }
    ]
  };

  return (
    <div className="analytics-page">
      <h2>Analytics</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">💬</div>
          <div className="stat-value">{stats.totalQueries.toLocaleString()}</div>
          <div className="stat-label">Total Queries</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✓</div>
          <div className="stat-value">{stats.answeredQueries.toLocaleString()}</div>
          <div className="stat-label">Answered</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">❓</div>
          <div className="stat-value">{stats.unansweredQueries}</div>
          <div className="stat-label">Unanswered</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">⚡</div>
          <div className="stat-value">{stats.avgResponseTime}</div>
          <div className="stat-label">Avg Response Time</div>
        </div>
      </div>
      <div className="top-queries">
        <h3>Top User Queries</h3>
        <div className="queries-list">
          {stats.topQueries.map((query, index) => (
            <div key={index} className="query-item">
              <div className="query-rank">#{index + 1}</div>
              <div className="query-text">{query.question}</div>
              <div className="query-count">{query.count} times</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
